import useApiWorker from 'hooks/useApiWorker';
import { EdfiDistrict } from 'types/edfi-district';
import { EdfiSchool } from 'types/edfi-school';

export async function GetDistrictsForState(): Promise<ApiListResponse<EdfiDistrict>> {
  const apiWorker = useApiWorker();
  return apiWorker
    .get<Array<EdfiDistrict>>(`/edfi/districts`)
    .then((result) => {
      return { success: true, data: result.data };
    })
    .catch((error) => {
      return {
        success: false,
        message: error.response.data.message,
      };
    });
}

export async function GetSchoolsForDistrictsForState(districtId?: string): Promise<ApiListResponse<EdfiSchool>> {
  const apiWorker = useApiWorker();
  return apiWorker
    .get<Array<EdfiSchool>>(`/edfi/schools/${districtId}`)
    .then((result) => {
      return { success: true, data: result.data };
    })
    .catch((error) => {
      if (error.response.status === 404) {
        return {
          success: false,
          message: `No district found with given District Id: ${districtId}`,
        };
      }
      return {
        success: false,
        message: error.response.data.message,
      };
    });
}
